const { default: def } = require("ajv/dist/vocabularies/applicator/additionalItems");

const supportedLocales = {
    GB: {
        currency: "GBP",
        currencySymbol: "£",
        rewardsLower: {
            amount: 24,
            discount: 20,
            couponId: "GC-REWARDS-20"
        },
        rewardsMid: {
            amount: 45,
            discount: 30,
            couponId: "GC-REWARDS-30"
        },
        rewardsHigh: {
            amount: 100,
            discount: 40,
            couponId: ""
        },
       
    },
    US: {
        currency: "USD",
        currencySymbol: "$",
        rewardsLower: {
            amount: 35,
            discount: 20,
            couponId: "GC-REWARDS-20"
        },
        rewardsMid: {
            amount: 65,
            discount: 30,
            couponId: "GC-REWARDS-30"
        },
        rewardsHigh: {
            amount: 150,
            discount: 40,
            couponId: ""
        },
    },
    AU: {
        currency: "AUD",
        currencySymbol: "$",
        rewardsLower: {
            amount: 48,
            discount: 20,
            couponId: "GC-REWARDS-20"
        },
        rewardsMid: {
            amount: 86,
            discount: 30,
            couponId: "GC-REWARDS-30"
        },
        rewardsHigh: {
            amount: 200,
            discount: 40,
            couponId: ""
        },
    }
};

const getCurrency = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.currency;
    } else {
        return locale.currency;
    }
}


 const getCurrencySymbol = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.currencySymbol;
    } else {
        return locale.currencySymbol;
    }
}

const getGamePricing = (countryCode, game, old = false) => {
    const priceSource = old ? game.oldPricing : game.pricing;
    return priceSource?.[countryCode?.toLowerCase()] ?? priceSource?.gb;
}

const getRewardsLower = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.rewardsLower;
    } else {
        return locale.rewardsLower;
    }
}

const getRewardsMid = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.rewardsMid;
    } else {
        return locale.rewardsMid;
    }
}

const getRewardsHigh = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.rewardsHigh;
    } else {
        return locale.rewardsHigh;
    }
}


export default {
    getCurrency,
    getCurrencySymbol,
    getGamePricing,
    getRewardsLower,
    getRewardsMid,
    getRewardsHigh
}